// extracted by mini-css-extract-plugin
export default {"wrapper":"_thNpk4QC4Uqho6AgJHv","button":"TtiTvsY6JQMkHoelyIzw","items":"VSyd3Ei3iPijvwwFUIEZ","dots":"Gse3mlzn3zTOFKLCrEiI"};